import { Tabs as MuiTabs, styled, tabsClasses } from "@mui/material";
import { getShouldForwardProp } from "../../../base/index.js";
import { tabsName } from "../classes.js";
const Root = styled(MuiTabs, {
  name: tabsName,
  slot: "Root",
  overridesResolver: (_props, styles) => [styles.root],
  shouldForwardProp: getShouldForwardProp()
})(
  ({ theme, ownerState }) => ownerState?.uiVariant === "white" ? {
    background: theme.vars.palette.primary.main,
    color: theme.vars.palette.primary.contrastText,
    [`& .${tabsClasses.indicator}`]: {
      backgroundColor: theme.vars.palette.primary.contrastText
    }
  } : {}
);
export {
  Root
};
//# sourceMappingURL=Root.js.map
